// extracted by mini-css-extract-plugin
module.exports = {"paneStatus":"BlogReviewHost_paneStatus__u71n3","review":"BlogReviewHost_review__eAJ2X","notice":"BlogReviewHost_notice__3vO57"};